/**
 * @file 代码Cell
 * @author FranckChen(chenfan02@baidu.com)
 */

import React, {memo, useMemo} from 'react';
import {crlf} from 'eol';
import hljs from 'highlight.js';

// component
import Output from './Output';

import {ICodeCell} from '../../types/codeCell';

// 目前预览仅支持python语言
hljs.registerLanguage(
    'python',
    require('highlight.js/lib/languages/python')
);

const CodeCell: React.FC<ICodeCell> = memo(function (props) {
    const {
        source,
        outputs
    } = props;

    const codeAreaHtml = useMemo(() => ({
        __html: hljs.highlight('python', crlf(source.join(''))).value
    }), [source]);

    return (
        <div className="ai-np-code">
            <pre>
                <code
                    className="hljs"
                    dangerouslySetInnerHTML={codeAreaHtml}
                />
            </pre>
            {outputs.map((outputData, index) => {
                return <Output output={outputData} key={index} />;
            })}
        </div>
    );
});

export default CodeCell;
